import { render, staticRenderFns } from "./BillingDocumentMaterialEditModal.vue?vue&type=template&id=50e595bc"
import script from "./BillingDocumentMaterialEditModal.vue?vue&type=script&lang=js"
export * from "./BillingDocumentMaterialEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports